import Actions from './constants';
import { IActionObject } from './types';

export function setYouVisitAnalyticsConfig(data: object): IActionObject {
  return { type: Actions.SET_ANALYTICS_CONFIG, data };
}

export default {
  setYouVisitAnalyticsConfig,
};
try {
    // @ts-ignore
    setYouVisitAnalyticsConfig.displayName = "setYouVisitAnalyticsConfig";
    // @ts-ignore
    setYouVisitAnalyticsConfig.__docgenInfo = { "description": "", "displayName": "setYouVisitAnalyticsConfig", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/youvisitAnalytics/actions.ts#setYouVisitAnalyticsConfig"] = { docgenInfo: setYouVisitAnalyticsConfig.__docgenInfo, name: "setYouVisitAnalyticsConfig", path: "src/store/youvisitAnalytics/actions.ts#setYouVisitAnalyticsConfig" };
}
catch (__react_docgen_typescript_loader_error) { }